/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');

class MarkCellValuesCommand extends RequestCommand {
	constructor(sheet, cellrefs, markers) {
		super(sheet);
		this.isVolatile = true;
		this.info = {
			// items: items.map((item) => item.getId()),
			markers: markers.map((marker, index) => ({ reference: cellrefs[index], marker }))
		}
	}
	getExecuteRequest() {
		return this.createRequest(this.info);
	}
	getRedoRequest() {}
	getUndoRequest() {}
	handleResult(/* result */) {}
}
module.exports = MarkCellValuesCommand;
